/**
 * This file handles the logic for the Find Your CL form.
 */

document.addEventListener( 'DOMContentLoaded', () => {

	const findYourCl = document.getElementById( 'find-your-cl' )
	const findYourClForm = document.getElementById( 'find-your-cl-form' )

	/**
	 * Display a message if the zipcode is invalid or not found.
	 */
	function showNoneFound() {
		const clResults = findYourCl.querySelector( '[data-cl-results]' )
		clResults.innerHTML = ''
		clResults.innerHTML = '<p class="b lh-copy mt4">There were no CLs that matched that zipcode. Please be sure you\'ve entered a valid zip code.</p>'
	}

	/**
	 * Clear the results area if the user wishes.
	 * Handles refreshing AOS for reflow.
	 */
	function clearResults() {
		const clearResultsButton = document.querySelector( '[data-close-cl-results]' )

		clearResultsButton.addEventListener( 'click', () => {
			const clResults = findYourCl.querySelector( '[data-cl-results]' )
			clResults.innerHTML = ''
			AOS.refresh()
			clearResultsButton.removeEventListener( 'click', clearResults )
		} )
	}

	/**
	 * Show the appropriate CL.
	 *
	 * @param {string} data The return response from the server.
	 */
	function showRelevantCl( data ) {
		const clResults = findYourCl.querySelector( '[data-cl-results]' )
		clResults.innerHTML = ''
		clResults.innerHTML = data
		findYourCl.appendChild( clResults )

		clearResults()
	}

	if ( findYourCl ) {

		// Prevent anything but number input in the zipcode field.
		findYourCl.addEventListener( 'keypress', ( e ) => {
			const code = ( e.which ) ? e.which : e.keyCode
			if ( code >= 97 && code <= 122 ) {
				e.preventDefault()
				return false
			}
			return true
		} )

		let ajaxUrl = `https://${window.location.host}/wp-admin/admin-ajax.php`

		jQuery( findYourClForm ).submit( ( e ) => {
			e.preventDefault()
			jQuery.ajax( {
				url: `${ajaxUrl}?action=find_your_cl`,
				type: 'post',
				data: jQuery( findYourClForm ).serialize(),
				success( data ) {
					if ( data ) {
						showRelevantCl( data )
						const loader = '<svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><defs> <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a"> <stop stop-color="#fff" stop-opacity="0" offset="0%"/> <stop stop-color="#fff" stop-opacity=".631" offset="63.146%"/> <stop stop-color="#fff" offset="100%"/> </linearGradient> </defs> <g fill="none" fill-rule="evenodd"> <g transform="translate(1 1)"> <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2"> <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite" /> </path> <circle fill="#fff" cx="36" cy="18" r="1"> <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite" /> </circle> </g> </g> </svg>'
						const videoPlayButtons = document.querySelectorAll( '[data-play-video]' )
						console.log( 'videoPlayButtons', videoPlayButtons )
						videoPlayButtons.forEach( videoPlayButton => {
							videoPlayButton.addEventListener( 'click', () => {
								const videoParent = videoPlayButton.closest( '[data-video-container]' )
								const videoPlaceholder = videoParent.querySelector( '[data-video-placeholder]' )
								const loadingButton = videoPlaceholder.querySelector( 'button' )
								loadingButton.innerHTML = loader
								loadingButton.style.left = '50%'
								loadingButton.style.top = '47%'
								loadingButton.style.maxWidth = '5rem'
								loadingButton.style.width = '5rem'
								console.log( 'loading!' )
								const video = videoParent.querySelector( '[data-perspective-video]' )
								const videoHolder = videoParent.querySelector( '.video-holder' )
								videoHolder.classList.add( 'dn' )
								const perspectiveVideo = new Plyr( video, {
									captions: {
										active: true
									},
									vimeo: {
										quality: '720p'
									}
								} )
								perspectiveVideo.on( 'ready', () => {
									perspectiveVideo.play()
								} )
								perspectiveVideo.on( 'playing', () => {
									videoHolder.classList.remove( 'dn' )
									videoPlaceholder.remove()
								} )
							} )
						} )

						const perspectives = document.querySelectorAll( '[data-copy-perspective-link]' )

						perspectives.forEach( perspective => {
							perspective.addEventListener( 'click', ( e ) => {
								e.preventDefault()
								// console.log( perspective );
								const currentPerspective = perspective.closest( '.perspective' )
								const linkToCopy = currentPerspective.querySelector( '[data-perspective-link-to-copy]' )
								// console.log( linkToCopy );
								linkToCopy.select()
								linkToCopy.setSelectionRange( 0, 99999 )
								document.execCommand( 'copy' )
								perspective.focus()
								// console.log( 'perspective', perspective );
								const copyNotification = currentPerspective.querySelector( '[data-fade-out-copy]' )
								// console.log( 'copyNotification', copyNotification );
								copyNotification.classList.remove( 'dn' )
								copyNotification.classList.add( 'di' )
								copyNotification.classList.remove( 'fade-out' )
								copyNotification.classList.add( 'fade-out' )
								// add fade-out, remove dn
							} )
						} )
					} else {
						showNoneFound()
					}
				},
				error() {
					console.error( 'There was an error with this request.' )
				}
			} )
		} )
	}
} )
